var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2491 2.13721L16.1273 1.16026C13.2739 0.0724877 10.1066 0.154248 7.31316 1.38779C4.51971 2.62133 2.32564 4.90705 1.2074 7.74863C1.1591 7.87047 1.1152 7.99012 1.07129 8.11087L10.7903 9.07245C12.6838 5.87157 14.6278 2.83315 15.2491 2.13721Z",
    fill: "#060A33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59923 17.5807C6.48946 17.4852 6.57618 17.1152 6.79791 16.551C6.88902 16.3216 7.00208 16.0582 7.1371 15.7662L0.422498 11.2305C0.306711 12.9817 0.589688 14.7363 1.25013 16.3623C1.91057 17.9883 2.93126 19.4433 4.23536 20.6177C5.53947 21.7921 7.09301 22.6555 8.77903 23.1426C10.4651 23.6298 12.2396 23.7282 13.9692 23.4303L8.34237 16.8408C7.39835 17.416 6.74962 17.7146 6.59923 17.5807Z",
    fill: "#060A33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0088 6.13502C21.5028 6.67179 21.1471 7.05049 20.9715 7.24588C20.6608 7.59275 19.8046 8.34248 18.6608 9.27332C17.517 10.2042 16.0714 11.337 14.5884 12.4566L16.7618 22.5785C18.2463 21.9101 19.5735 20.9368 20.6571 19.7218C21.7407 18.5069 22.5564 17.0775 23.0513 15.5265C23.5462 13.9756 23.7091 12.3379 23.5295 10.7198C23.3499 9.10179 22.8318 7.53966 22.0088 6.13502Z",
    fill: "#060A33"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueIcon);
export default __webpack_public_path__ + "static/media/blue-icon.34f5d78114749233b42f295e338d8f6e.svg";
export { ForwardRef as ReactComponent };